//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { eventEmitter } from "@/main.js";
import { mapGetters, mapActions } from "vuex";
export default {
	name: "DonutTile",
	data: () => ({
		data: [],
		loading: false,
	}),
	async created() {
		await this.fetchData();
		this.loading = false;
	},
	methods: {
		...mapActions(["globalMetrics"]),

		async fetchData() {
			try {
				this.loading = true;
				const { market_cap_percentage: data } = await this.globalMetrics();
				this.data = data;
				this.loading = false;
			} catch (e) {
				this.loading = false;
				console.warn("Error while executing Global metrics request", e);
			}
		},
	},
	computed: {
		chartData() {
			return this.data;
		},
	},
};
